export default __webpack_public_path__ + "static/fakegoogle_2-785e72c592391ddde8fcb958ab9b23f5.jpg";